import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { FetchDatosDebitoAutomatico, FetchObtenerConductos } from "../../../../redux/actions/aCotizacion";
import DebitoAutomaticoRenovacion from "./DebitoAutomaticoRenovacion";

class ContainerDebitoAutomaticoRenovacion extends Component {
  constructor(props) {
    super(props);

    this.state = {
      esMismaPersona: true,
      mostrar: false,
      pagador: null
    };
  }

  componentDidMount() {

    let ramo = this.props.dataFacturacion.datosFacturacion.carDescripcionRamo ? this.props.dataFacturacion.datosFacturacion.carDescripcionRamo : '';
    if (this.props.dataFacturacion && this.props.dataFacturacion.datosFacturacion && this.props.dataFacturacion.datosFacturacion.carDescripcionSeguro && this.props.dataFacturacion.datosFacturacion.carDescripcionSeguro !== '' && this.props.dataFacturacion.datosFacturacion.carDescripcionSeguro !== null) {
      ramo = this.props.dataFacturacion.datosFacturacion.carDescripcionSeguro
    }

    this.props.listarDebitoAutomatico({
      "empresa": "AIGMETROPOLITANA",
      "ramo": ramo
    })

    this.props.listarConductos({
      "empresa": "AIGMETROPOLITANA",
      "plataforma": "WEB",
      "idCliente": this.props.dataFacturacion.datosFacturacion.datosPagador ? this.props.dataFacturacion.datosFacturacion.datosPagador[0].id : null,//this.props.datosCarrito.productosCarrito.carDatosPagadorFacturacion[0].id,
      "idCarrito": this.props.datosCarrito.productosCarrito.idCarrito
    })
    let data = this.props.datosCarrito.productosCarrito

    let carDatosContratante = data && data.carDatosContratante ? data.carDatosContratante : null;

    // Asegurado
    let datosAsegurado = data
      && data.carProductos
      && data.carProductos[0]
      && data.carProductos[0].datosAsegurado
      ? data.carProductos[0].datosAsegurado
      : null;

    let esMismaPersona = carDatosContratante
      && datosAsegurado
      && carDatosContratante.cliIdentificacion === datosAsegurado.cedula;

    this.setState({
      esMismaPersona: esMismaPersona,
      pagador: carDatosContratante,
      mostrar: true
    });
  }

  render() {

    return (
      <main className="cr-app bg-light">
        <div className="cr-content container-fluid">
          <div className="container-body-spaces">
            {this.state.mostrar &&
              <DebitoAutomaticoRenovacion esMismaPersona={this.state.esMismaPersona} pagador={this.state.pagador} />
            }
          </div>
        </div>
      </main>
    );

  }
}

const mapStateToProps = state => ({
  dataUsuario: state.datosUsuarios.dataUsuario,
  datosCarrito: state.dataProductoCarrito,
  dataFacturacion: state.dataFacturacion
});

const mapDispatchToProps = dispatch => {
  return {
    listarDebitoAutomatico: datos => dispatch(FetchDatosDebitoAutomatico(datos)),
    listarConductos: datos => dispatch(FetchObtenerConductos(datos)),
  };
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(ContainerDebitoAutomaticoRenovacion)
);
